let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9yVDq")).then(() => parcelRequire('3cACL'));